export default __webpack_public_path__ + "static/media/joint-treasurer.8707df70.jpg";